module.exports = __webpack_public_path__ + "assets/img/ico_android.b537cbf2.svg";